import { render, staticRenderFns } from "./EocLocBadge.vue?vue&type=template&id=01927d26&"
import script from "./EocLocBadge.vue?vue&type=script&lang=js&"
export * from "./EocLocBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports